import secondaryButtonLightGrayHover from '../../../../../common/algorithms/secondary-button-light-gray-hover';

const primary = (params) => secondaryButtonLightGrayHover(params);

export default primary;
